var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddsymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF9800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3256_44062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7401 8.62324H8.62324V11.7401C8.62324 12.083 8.34272 12.3635 7.99987 12.3635C7.65701 12.3635 7.37649 12.083 7.37649 11.7401V8.62324H4.25961C3.91675 8.62324 3.63623 8.34272 3.63623 7.99987C3.63623 7.65701 3.91675 7.37649 4.25961 7.37649H7.37649V4.25961C7.37649 3.91675 7.65701 3.63623 7.99987 3.63623C8.34272 3.63623 8.62324 3.91675 8.62324 4.25961V7.37649H11.7401C12.083 7.37649 12.3635 7.65701 12.3635 7.99987C12.3635 8.34272 12.083 8.62324 11.7401 8.62324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3256_44062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6364,
    height: 11.6364,
    fill: "white",
    transform: "translate(2.18164 2.18164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddsymbol);
export default __webpack_public_path__ + "static/media/Addsymbol.3308e8e5ef6e7214a0741e5ec83b2a69.svg";
export { ForwardRef as ReactComponent };